import React, { useEffect, useState } from "react";
import {
  DraggableItem,
  DroppableContainer,
} from "../components/admin/DndTemplate/helper/DndHelper";
import { AllFields } from "../components/admin/DndTemplate/constant/Constant";
import { DragDropContext } from "react-beautiful-dnd";
import {
  fieldsDetail,
  isFormAtom,
} from "../components/admin/DndTemplate/DndAtom/DndTemplateAtom";
import { useAtom } from "jotai";
import { clinicAtom } from "../_helper/constant/constant-atom";
import DropBox from "./component/DropBox";
// import Draggable from "react-draggable";
const StepCreator = ({ form, setForm }) => {
  const [selectedValue, setSelectedValue] = useState(true);
  const [predefinedFields, setPredefinedFields] = useState([]);
  const [isForm, setIsForm] = useAtom(isFormAtom);
  const [fields, setFields] = useAtom(fieldsDetail);
  const [clinic] = useAtom(clinicAtom);

  const onDragEndHandler = (result) => {
    if (!result.destination) {
      return;
    }

    const { draggableId, source, destination } = result;
    const { droppableId: sourceDroppableId } = source;
    const { droppableId: destDroppableId } = destination;

    if (sourceDroppableId === "source" && destDroppableId === "dest") {
      const id = `${fields.length > 0 ? fields.length + 1 : 1}`;
      const newField = {
        id: id,
        display_name: `Custom Field ${id}`,
        type: draggableId,
        created: false,
      };
      setFields([...fields, newField]);
      setIsForm({ isForm: true, id: id, isOpen: true, isEdit: true });
    }
  };
  return (
    <DragDropContext onDragEnd={onDragEndHandler}>
      <div className="w-full m-auto helvetica">
        <div className="flex gap-4">
          <div className=" flex-1">
            <div className=" gap-2 flex items-center">
              <div className="w-[182px] xl:w-[138.52px] large:w-[147.83px] xlarge:w-[207.78px] "></div>
            </div>
            <div className="w-full min-h-[488.89px] border-dashed border border-[#757575] mt-5 rounded-lg p-5 text-[#999999]">
              <DropBox
                selectedValue={selectedValue}
                predefinedFields={predefinedFields}
              />
            </div>
          </div>

          <div className="cu-all-fields w-[348.45px] xl:w-[435.56px] large:w-[464.83px] xlarge:w-[653.34px] rounded-lg p-4 text-[8.3px] xl:text-[10.37px] large:text-[11.07px] xlarge:text-[15.56px] border">
            <DroppableContainer droppableId="source" className={""}>
              <div className="">
                {AllFields.map((field, index) => (
                  <div key={index} className="flex justify-between gap-4 mt-4">
                    {/* <DraggableItem
                      item={{
                        id: field.name,
                        content: field.name,
                      }}
                      index={index}
                    /> */}
                    {field?.name}
                    <div className="lg:h-[28.85px] xl:h-[35.81px] large:h-[38.81px] xlarge:h-[54.22px]  border rounded-lg w-[213.34px] xl:w-[266.67px] large:w-[284.59px] xlarge:w-[400px]">
                      <DraggableItem
                        item={{
                          id: field.name,
                          content: field.example,
                          class: "h-full w-full rounded-lg flex  items-center",
                        }}
                        index={index}
                      />
                      {/* {field.example} */}
                    </div>
                  </div>
                ))}
              </div>
            </DroppableContainer>
          </div>
        </div>
      </div>
    </DragDropContext>
  );
};

export default StepCreator;
